/**
 * @Description This is FasatButtonSelector component page.
 * This is a wrapper on "ButtonSelector" component from MUX without adding any custom functionlities
 * @FileName fasatButtonSelector.js
 * @Author Imroz Dawar- dawarim
 * @CreatedOn 5 February, 2021 12:02:10
 * @IssueID CDTFASATMOD- 325
 */
import React, { useCallback } from 'react';
import { ButtonSelector } from '@manulife/mux';
import './fasatButtonSelector.scss';
import PropTypes from 'prop-types';

const fasatButtonSelector = 'fasatButtonSelector';
function FasatButtonSelector(props) {
  const { onHandleChange, 'data-testid': dataTestId, value, ariaLabel, 'aria-label': ariaLabelProp, ...rest } = props;
  const accessibilityLabel = ariaLabel || ariaLabelProp;
  const changeHandler = useCallback((val) => onHandleChange(val), [onHandleChange]);
  return (
    <div className={fasatButtonSelector}>
      <ButtonSelector {...rest} data-testid={dataTestId} onChange={changeHandler} selected={value} aria-label={accessibilityLabel} />
    </div>
  );
}
FasatButtonSelector.propTypes = {
  onHandleChange: PropTypes.func,
};
FasatButtonSelector.defaultProps = {
  onHandleChange: () => undefined,
};
export default FasatButtonSelector;
